import React from "react";

const HairStraighteningService = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>Our Hair Straightening Services in Bangalore</h3>
      <p>
        SCENT offers a variety of hair straightening treatments, each designed
        to cater to specific hair types and preferences. Here’s a closer look at
        what you can expect from our hair straightening salon in Bangalore:
      </p>
      <li>
        <h6>Keratin Hair Straightening</h6>
        <p>
           Our keratin hair straightening treatment
          is ideal for those seeking a natural look with reduced frizz. This
          treatment infuses keratin protein into your hair, which strengthens
          and smooths each strand. The result is frizz-free, manageable hair
          with a natural-looking straightness that lasts for up to three months.
        </p>
      </li>
      <li>
        <h6>Rebonding Hair Straightening</h6>
        <p>
          If you desire sleek, pin-straight
          hair, our rebonding service may be the perfect option for you. This
          chemical-based treatment works by breaking down the hair’s natural
          structure and rebuilding it in a straight form. Rebonding is
          especially effective for those with curly or wavy hair who want a
          long-lasting straight look.
        </p>
      </li>
      <li>
        <h6> Smoothening Treatments</h6>
        <p>
           Our smoothening treatments are designed for
          clients who want a more subtle straightening effect. Smoothening helps
          eliminate frizz, enhances shine, and softens curls, resulting in a
          smooth, polished appearance.
        </p>
      </li>
    </div>
  );
};

export default HairStraighteningService;
